export default "__VITE_ASSET__CtCsHyso__"